import React, { useState, useEffect } from 'react'
import './styles.scss'
import { browserCheck } from '@ta-interaktiv/browsercheck'

import {
  NOMINATIMPROPS,
  MAXRESULTZOOM,
  AREAMARKERPROPS
} from '../../images/settings.js'
import { InterfaceMapBox } from 'types/IMapBox'

// const Nominatim = require('nominatim-geocoder')
// const geocoder = new Nominatim()
// const nominatim = require('nominatim-geocode')

const nominatimAdressKeyAliases: { [key: string]: string[] } = {
  locality: [],
  // eslint-disable-next-line @typescript-eslint/camelcase
  house_number: ['street_number'],
  house: ['building', 'public_building'],
  road: [
    'footway',
    'street',
    'street_name',
    'residential',
    'path',
    'pedestrian',
    'road_reference',
    'road_reference_intl'
  ],
  village: ['hamlet', 'locality', 'croft'],
  neighbourhood: [
    'suburb',
    'city_district',
    'district',
    'quarter',
    'houses',
    'subdivision'
  ],
  city: ['town', 'municipality'],
  county: ['local_administrative_area', 'county_code'],
  postcode: [],
  // eslint-disable-next-line @typescript-eslint/camelcase
  state_district: [],
  state: ['province', 'state_code'],
  region: [],
  island: [],
  country: ['country_name'],
  // eslint-disable-next-line @typescript-eslint/camelcase
  country_code: [],
  continent: []
}
const getViaAliases = (result: NominatimAddress, prop: string) => {
  if (result[prop]) return result[prop]
  if (nominatimAdressKeyAliases[prop].length > 0) {
    var ret = ''
    for (var i = 0; i < nominatimAdressKeyAliases[prop].length; i++) {
      if (result[nominatimAdressKeyAliases[prop][i]]) {
        ret = result[nominatimAdressKeyAliases[prop][i]]
        break
      }
    }
    return ret
  }
}
const resultFilter: NominatimAdressFilter = {
  show: [
    'locality',
    'house',
    'road',
    'village',
    'neighbourhood',
    'city',
    'state',
    'country'
  ],
  hideValue: {
    class: ['tourism', 'landuse', 'historic', 'office'],
    type: ['parking', 'bicycle_parking', 'bus_stop']
  },
  format: {
    default: (result: NominatimAddress = {}, prop: string = '') => {
      return getViaAliases(result, prop)
    },
    road: (result: NominatimAddress = {}) => {
      var ret = getViaAliases(result, 'road')
      if (getViaAliases(result, 'house_number')) {
        ret += ' ' + getViaAliases(result, 'house_number')
      }
      return ret
    },
    state: (result: NominatimAddress = {}) => {
      return 'Kanton ' + getViaAliases(result, 'state')
    },
    country: (result: NominatimAddress = {}) => {
      if (getViaAliases(result, 'country')) {
        if (Object.keys(result).length === 2)
          return getViaAliases(result, 'country')
      }
    }
  }
}

interface InterfaceSearch {
  map: InterfaceMapBox
  locales: {
    placeholder: string
    noEntry: string
    search: string
    position: string
  }
}
interface InterfaceTextInput {
  initialValue?: string
  placeholder?: string
  searchFunktion: Function
  switchResults: Function
}
interface NominatimAddress {
  [key: string]: string
}
interface NominatimResult {
  address: { [key: string]: string }
  boundingbox: string[]
  class: string
  // eslint-disable-next-line @typescript-eslint/camelcase
  display_name: string
  displayName?: string
  geojson: { type: string; coordinates: number[][] }
  importance: number
  lat: string
  licence: string
  lon: string
  // eslint-disable-next-line @typescript-eslint/camelcase
  osm_id: number
  // eslint-disable-next-line @typescript-eslint/camelcase
  osm_type: string
  // eslint-disable-next-line @typescript-eslint/camelcase
  place_id: number
  type: number
}
interface NominatimAdressFilter {
  show: string[]
  hideValue: { [key: string]: string[] }
  format: { [key: string]: Function }
}
interface InterfaceFormatedResult {
  name: string
  pos?: number[]
  geojson?: {
    coordinates: number[][]
    type: string
  }
  boundingbox?: string[]
  iserror?: boolean
}

const formatNominatimAdress = (
  result: NominatimResult,
  options: NominatimAdressFilter
) => {
  // console.groupCollapsed('RESULT')
  // console.log(result)
  const hides: { [key: string]: string[] } = options.hideValue
  const shows: string[] = options.show
  const address = result.address
  var ret = []
  // Hide results by values of selected properties
  for (var p in hides) {
    if (result[p]) {
      if (hides[p].indexOf(result[p]) >= 0) {
        // console.groupEnd()
        return
      }
    }
  }
  // Use provided formatters to format property values
  for (var i = 0; i < shows.length; i++) {
    if (getViaAliases(address, shows[i])) {
      if (options.format[shows[i]]) {
        ret.push(options.format[shows[i]](address))
      } else {
        if (options.format.default)
          ret.push(options.format.default(address, shows[i]))
      }
    }
  }
  // console.groupEnd()

  // Remove empty and convert to string
  return ret.filter(Boolean).join(', ')
}

const TextInput = ({
  initialValue = '',
  searchFunktion,
  placeholder = '',
  switchResults
}: InterfaceTextInput) => {
  const [value, setValue] = useState(initialValue)
  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  const updateValue = (e: { currentTarget: { value: string } }) => {
    setValue(capitalizeFirstLetter(e.currentTarget.value))
  }
  const listenForReturn = (e: {
    keyCode: number
    preventDefault: Function
  }) => {
    if (e.keyCode === 13) {
      searchFunktion()
    }
    if (e.keyCode === 40) {
      e.preventDefault()
      console.log(document.getElementById('results').children[0])

      if (document.getElementById('results'))
        document.getElementById('results').children[0].focus()
    }
    if (e.keyCode === 38) {
      e.preventDefault()
      if (document.getElementById('results'))
        document
          .getElementById('results')
          .children[
            document.getElementById('results').children.length - 1
          ].focus()
    }
  }

  const receivefocus = () => {
    // if (value.length > 0)
    switchResults(true)
  }
  const clearValue = () => {
    setValue('')
    switchResults(false)
  }
  return (
    <form action='#'>
      <div className='ui icon input'>
        <input
          title='Suche'
          type='text'
          id='nominatimQuery'
          placeholder={placeholder}
          value={value}
          onChange={updateValue}
          onKeyDown={listenForReturn}
          onFocus={receivefocus}
          autoComplete='off'
        />
        <i className='x icon' onClick={clearValue} />
        <i className='search icon' onClick={searchFunktion} />
      </div>
    </form>
  )
}
export const NominatimSearch = ({ map, locales }: InterfaceSearch) => {
  // State
  const [results, setResults] = useState([])
  const [locator, setLocator] = useState(false)
  const [isSearching, setSearching] = useState(false)
  const [showResults, switchResults] = useState(false)

  useEffect(() => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        () => {
          setLocator(true)
        },
        e => {
          console.warn(e)
        }
      )
    }
  }, [])
  // Methods
  const switchSearching = (state: boolean) => {
    setSearching(state)
  }
  const scrollToMap = () => {
    const offset = (el: HTMLElement) => {
      var rect = el.getBoundingClientRect()
      var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
    window.scrollTo(0, offset(document.getElementById('nominatim')).top - 20)
  }
  const goToMyPosition = () => {
    scrollToMap()
    navigator.geolocation.getCurrentPosition(
      function(position) {
        map.marker.setLngLat([
          position.coords.longitude,
          position.coords.latitude
        ])
        map.flyTo({
          center: [position.coords.longitude, position.coords.latitude],
          zoom: 16
        })
        switchResults(false)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'Interactions',
          // eslint-disable-next-line @typescript-eslint/camelcase
          event_action: browserCheck.isTouch ? 'tap' : 'click',
          // eslint-disable-next-line @typescript-eslint/camelcase
          event_label: 'showMyPosition'
        })
      },
      e => {
        console.warn(e)
      },
      { enableHighAccuracy: true, timeout: 20000 }
    )
  }
  const goToResult = (
    map: InterfaceMapBox,
    result: InterfaceFormatedResult,
    switchResults: Function
  ) => {
    if (result.name === locales.noresult) return
    const geojson = result.geojson || { type: 'Polygon', coordinates: [[0, 0]] }
    const box = result.boundingbox
    var bbox: [[number, number], [number, number]] = [
      [0, 0],
      [0, 0]
    ]
    if (box)
      bbox = [
        [+box[2], +box[0]],
        [+box[3], +box[1]]
      ]

    // initalize result shape layer
    if (!map.getSource('maine')) {
      map.addSource('maine', { type: 'geojson', data: geojson })
      map.addLayer({
        id: 'maine',
        type: 'line',
        source: 'maine',
        layout: {},
        paint: {
          'line-color': AREAMARKERPROPS.lineColor,
          'line-width': AREAMARKERPROPS.lineWidth
        }
      })
    }
    switchResults(false)
    // move marker
    map.marker.setLngLat(result.pos)

    // change or remove content of result shape layer
    if (geojson.type === 'Polygon' || geojson.type === 'MultiPolygon') {
      map.getSource('maine').setData(geojson)
    } else {
      map.getSource('maine').setData({ type: 'Polygon', coordinates: [[0, 0]] })
    }
    // go to location on map
    map.fitBounds(bbox, { maxZoom: MAXRESULTZOOM })

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_action: browserCheck.isTouch ? 'tap' : 'click',
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_label: 'goToResult'
    })
  }

  const search = (setResults: Function, switchSearching: Function) => {
    const curBounds = map.getBounds()
    scrollToMap()
    NOMINATIMPROPS.q = document.getElementById('nominatimQuery').value
    NOMINATIMPROPS.viewbox = [
      curBounds._ne.lng,
      curBounds._ne.lat,
      curBounds._sw.lng,
      curBounds._sw.lat
    ].join(',')
    var query = ''
    for (var p in NOMINATIMPROPS) {
      query += p + '=' + NOMINATIMPROPS[p] + '&'
    }
    console.log(query)
    fetch(`https://nominatim.openstreetmap.org/search?` + query)
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(response.status.toString())
      })
      .then(response => {
        const filteredResponse = response.filter(function(a) {
          var key = JSON.stringify(a.address)
          if (!this[key]) {
            this[key] = true
            return true
          }
        }, Object.create(null))
        switchSearching(false)
        var formatedResults: InterfaceFormatedResult[] = []
        filteredResponse.forEach(r => {
          r.displayName = formatNominatimAdress(r, resultFilter)
          if (r.displayName)
            formatedResults.push({
              name: r.displayName,
              pos: [+r.lon, +r.lat],
              geojson: r.geojson,
              boundingbox: r.boundingbox
            })
        })
        if (formatedResults.length === 0) {
          formatedResults = [{ name: locales.noresult, iserror: true }]
        }
        setResults(formatedResults)
      })
  }

  const startSearch = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_action: browserCheck.isTouch ? 'tap' : 'click',
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_label: 'startSearch'
    })
    setResults([])
    switchSearching(true)
    switchResults(true)
    search(setResults, switchSearching)
  }
  const hideResults = () => {
    switchResults(false)
  }
  const resultKeyDown = (e, result) => {
    if (e.keyCode === 40) {
      e.preventDefault()
      if (e.currentTarget.nextSibling) {
        e.currentTarget.nextSibling.focus()
      } else {
        document.getElementById('nominatimQuery').focus()
      }
    }
    if (e.keyCode === 38) {
      e.preventDefault()
      if (e.currentTarget.previousSibling) {
        e.currentTarget.previousSibling.focus()
      } else {
        document.getElementById('nominatimQuery').focus()
      }
    }
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault()
      if (result.myPos) {
        goToMyPosition()
      } else {
        goToResult(map, result, switchResults)
      }
    }
  }
  return (
    <>
      <div id='nominatim'>
        <TextInput
          searchFunktion={startSearch}
          placeholder={locales.placeholder}
          switchResults={switchResults}
        />
        {showResults && (
          <div className='resultList' id='resultList'>
            <ul role='listbox' id='results'>
              {showResults && (
                <>
                  {locator && (
                    <li
                      className='result'
                      onClick={goToMyPosition}
                      onKeyDown={e => {
                        resultKeyDown(e, { myPos: true })
                      }}
                      tabIndex={0}
                      role='option'
                    >
                      <b>{locales.position}</b>
                    </li>
                  )}
                  {results.map((result: NominatimResult, i: number) => {
                    return (
                      <li
                        role='option'
                        tabIndex={0}
                        key={i + ''}
                        className={result.iserror ? 'result nolink' : 'result'}
                        onClick={() => {
                          goToResult(map, result, switchResults)
                        }}
                        onKeyDown={e => {
                          resultKeyDown(e, result)
                        }}
                      >
                        {result.name}
                      </li>
                    )
                  })}
                </>
              )}
            </ul>
            {showResults && results.length > 0 && (
              <div className='resultClose '>
                <button className='closeButton' onClick={hideResults} />
              </div>
            )}
            {isSearching && (
              <div className='result searching'>{locales.search}</div>
            )}
          </div>
        )}
      </div>
    </>
  )
}
